<template>
  <div
    v-if="canChoosePaymentOption"
    :class="$style.base"
    v-test="'payment-select'"
  >
    <div :class="$style.label">{{ $t('confirmation.payment') }}</div>
    <BaseRadio
      v-if="notFullyPaid"
      v-model="paymentMethod"
      :options="paymentMethodOptions"
      variant="check"
    />
    <div v-else v-test="'paid-with-giftcard'">
      {{ $t('confirmation.paid_with_giftcard') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseRadio from '@/components/BaseRadio.vue';
import { useBookingStore } from '@/stores/booking';
import type { PaymentMethodOptions } from '@/types';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

type PaymentMethodOption = {
  label: string;
  value: PaymentMethodOptions;
}[];

const { t } = useI18n();
const { pricing, paymentMethod, giftcardRedeemedAmount } = storeToRefs(
  useBookingStore()
);

const canChoosePaymentOption = computed(() => {
  return pricing.value?.quote?.payment_strategy === 'optional';
});

const notFullyPaid = computed(() => {
  return (
    pricing.value && pricing.value?.quote?.total > giftcardRedeemedAmount.value
  );
});

const paymentMethodOptions: PaymentMethodOption = [
  {
    label: t('confirmation.pay_at_location'),
    value: 'pay_at_location'
  },
  {
    label: t('confirmation.pay_online'),
    value: 'pay_online'
  }
];
</script>

<style lang="scss" module>
.base {
  margin: $spacing * 2 0;
}

.label {
  font-weight: bold;
}
</style>
